import { RenderFormat, ViewerDocumentKind, ViewerDownloadTargetKind, ViewerOpenContextKind, type ContentViewerSession } from '@/content-viewer/store/schemas'
import type { TableReferenceTarget } from '../reference'

/** Preserve table evidence while using the shared viewer's document capabilities. */
export function buildTableReferenceSession(reference: TableReferenceTarget, conversationId?: string): ContentViewerSession | null {
  if (reference.web_url) return null
  const context = { kind: ViewerOpenContextKind.SELECTED_FILE, conversationId } as const
  const presentation = {
    startingPage: reference.page_number ? reference.page_number - 1 : undefined,
    pdfExcerpt: reference.excerpt ?? undefined,
    markdownHighlights: reference.excerpt ? [reference.excerpt] : [],
  }
  if (reference.docket_table_id && reference.id) {
    return {
      document: { kind: ViewerDocumentKind.DOCKET, tableId: reference.docket_table_id, referenceId: reference.id, title: reference.document_name },
      context,
      presentation,
    }
  }
  if (reference.agency_table_id && reference.id) {
    return {
      document: {
        kind: ViewerDocumentKind.AGENCY,
        tableId: reference.agency_table_id,
        referenceId: reference.id,
        title: reference.document_name,
        downloadTarget: { kind: ViewerDownloadTargetKind.AGENCY_ORIGINAL, tableId: reference.agency_table_id, referenceId: reference.id },
      },
      context,
      presentation,
    }
  }
  if (reference.legal_path && reference.legal_kind) {
    const kind = reference.legal_kind === 'caselaw' ? ViewerDocumentKind.CASELAW : ViewerDocumentKind.LRR
    const document = {
      s3Path: reference.legal_path,
      title: reference.document_name,
      renderAsset: { format: RenderFormat.HTML, sourceKind: kind, storagePath: reference.legal_path },
      downloadTarget: {
        kind: ViewerDownloadTargetKind.RICH_REFERENCE_DOCX,
        sourceKind: kind,
        storagePath: reference.legal_path,
        fileName: reference.document_name,
      },
    } as const
    return { document: kind === ViewerDocumentKind.CASELAW ? { ...document, kind, parentId: '' } : { ...document, kind }, context, presentation }
  }
  if (!reference.document_id) return null
  return {
    document: {
      kind: ViewerDocumentKind.USER_FILE,
      userFileId: reference.document_id,
      title: reference.document_name,
      downloadTarget: { kind: ViewerDownloadTargetKind.USER_FILE_ORIGINAL, userFileId: reference.document_id },
    },
    context,
    presentation,
  }
}
